import React from "react";
import { GitHub, WarningAmberOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

// ── Helpers ───────────────────────────────────────────────────────────────────

const GITHUB_ROLE_STYLE = {
  OWNER: { background: "#fff7ed", color: "#c2500a", border: "1px solid #fed7aa" },
  MEMBER: { background: "#f0f9e6", color: "#4d7a10", border: "1px solid #c6e890" },
};

function caseMatch(a, b) {
  return a?.toLowerCase() === b?.toLowerCase();
}

// ── Component ─────────────────────────────────────────────────────────────────

const GitHubSection = ({ user, arbiterJoinedOrgNames }) => {
  const ownerCount = user.organizations.filter((o) => o.role === "OWNER").length;

  return (
    <div className="ecr-us__section-body">
      {/* User header */}
      <div className="ecr-us__gh-header">
        <div className="ecr-us__gh-avatar-wrap">
          <img
            className="ecr-us__gh-avatar"
            src={user.avatar_url}
            alt={user.user_name}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <div className="ecr-us__gh-badge">
            <GitHub style={{ fontSize: 12 }} />
          </div>
        </div>

        <div>
          <h3 className="ecr-us__ad-name">{user.user_name || "—"}</h3>
          <a
            href={`https://github.com/${user.user_login}`}
            target="_blank"
            rel="noreferrer"
            className="ecr-us__gh-login"
          >
            @{user.user_login}
          </a>
        </div>

        <div className="ecr-us__gh-stats">
          {[
            { n: user.organizations.length, label: "Orgs" },
            { n: ownerCount, label: "Owner" },
          ].map(({ n, label }) => (
            <div key={label} className="ecr-us__gh-stat">
              <span className="ecr-us__gh-stat-num">{n}</span>
              <span className="ecr-us__gh-stat-lbl">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Org grid */}
      <p className="ecr-us__sub-heading" style={{ marginTop: 16 }}>
        Organizations ({user.organizations.length})
      </p>
      <div className="ecr-us__org-grid">
        {user.organizations.map((org) => {
          const notJoinedInArbiter =
            arbiterJoinedOrgNames.length > 0 &&
            !arbiterJoinedOrgNames.some((n) => caseMatch(n, org.login));

          return (
            <div
              key={org.login}
              className={`ecr-us__org-card ${notJoinedInArbiter ? "ecr-us__org-card--issue-github" : ""}`}
            >
              <img
                src={org.avatar_url}
                alt={org.login}
                className="ecr-us__org-avatar"
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <span className="ecr-us__org-name">{org.login}</span>
              <span
                className="ecr-us__org-badge"
                style={GITHUB_ROLE_STYLE[org.role] || GITHUB_ROLE_STYLE.MEMBER}
              >
                {org.role}
              </span>
              {notJoinedInArbiter && (
                <Tooltip title="Not Joined in Arbiter for this org">
                  <WarningAmberOutlined className="ecr-us__warn-icon" />
                </Tooltip>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GitHubSection;
